import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=130165a8&scoped=true&"
import script from "./ContactForm.vue?vue&type=script&lang=js&"
export * from "./ContactForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=130165a8&lang=stylus&scoped=true&"
import style1 from "./ContactForm.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130165a8",
  null
  
)

export default component.exports